"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const tokens = __importStar(require("@trp-rps-rps-shared-web/rps-shared-web-styles"));
const StyledContainer = styled_components_1.default.div `
  width: 98px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-family: Nimbus Sans Regular;
  outline: none;
  @media only screen and (max-width: 767px) {
    width: 114px;
  }
`;
const StyledInnerContainer = styled_components_1.default.div `
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  margin-top: 16px;
  @media only screen and (max-width: 767px) {
    margin-top: ${props => (props.title ? "16px" : "0px")};
  }
`;
const StyledTitle = styled_components_1.default.div `
  font-family: Nimbus Sans Bold;
  font-size: 14px;
  color: ${tokens.ColorGrey900};
`;
const StyledHelperText = styled_components_1.default.div `
  font-size: 14px;
  color: ${tokens.ColorGrey600};
`;
const StyledImage = styled_components_1.default.img `
  width: 24px;
  height: 24px;
  margin: 0px 16px;
  @media only screen and (max-width: 767px) {
    width: 32px;
    height: 32px;
  }
`;
const keyDown = (e, onClickEvent) => {
    const code = e.key;
    if (code === 'Enter' || code === ' ') {
        e.preventDefault();
        return onClickEvent();
    }
};
class IncrementDecrement extends react_1.Component {
    render() {
        const _a = this.props, { id, title, value, onPlusClick, onMinusClick, helperText, maxValue, minValue } = _a, rest = __rest(_a, ["id", "title", "value", "onPlusClick", "onMinusClick", "helperText", "maxValue", "minValue"]);
        const idPrefix = id ? id + '-' : '';
        return (react_1.default.createElement(StyledContainer, { tabIndex: 0 },
            title && react_1.default.createElement(StyledTitle, { id: idPrefix + `increment-decrement-title` }, title),
            react_1.default.createElement(StyledInnerContainer, { title: title, id: idPrefix + `inner-title` },
                react_1.default.createElement(StyledImage, { src: `data:image/svg+xml;base64,${value > minValue
                        ? tokens.AssetIconMinusOutline
                        : tokens.AssetIconDisabledMinusOutline}`, onClick: value > minValue ? onMinusClick : undefined, tabIndex: 0, onKeyPress: (e) => keyDown(e, value > minValue ? onMinusClick : undefined), alt: "minus icon", id: idPrefix + `minus-icon` }),
                react_1.default.createElement("span", { id: idPrefix + `increment-decrement-value` }, value),
                react_1.default.createElement(StyledImage, { src: `data:image/svg+xml;base64,${value < maxValue
                        ? tokens.AssetIconPlusOutline
                        : tokens.AssetIconDisabledPlusOutline}`, onClick: value < maxValue ? onPlusClick : undefined, tabIndex: 0, onKeyPress: (e) => keyDown(e, value < maxValue ? onPlusClick : undefined), alt: "plus icon", id: idPrefix + `plus-icon` })),
            react_1.default.createElement(StyledHelperText, { id: idPrefix + `helper-text` }, helperText)));
    }
}
exports.default = IncrementDecrement;
//# sourceMappingURL=IncrementDecrement.js.map